const queryParam = (value, defaultValue = null) => {
  if (value == null || value.trim() === '') return defaultValue;
  if (!isNaN(value)) return parseFloat(value);
  if (['true', 'false'].includes(value.toLowerCase()))
    return value.toLowerCase() === 'true';
  return value.trim();
};

export default queryParam;
